module.exports = __webpack_public_path__ + "static/media/poli.5f30aade.jpg";